export function moverConfiguracoes(estado) {
  return {
    type : estado === 'CONTRAIDO' ? 'CONFIGURACOES_EXPANDIR' : 'CONFIGURACOES_CONTRAIR'
  }
}